import React, { useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../api/queries/loginAPI";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../contexts/UserContext/UserContext";
import { Button } from "@mui/material";
import { HMI_PATHS, LocalStorageGlobalKeys } from "constants/constants";
import { resetLocalStorage } from "utilities/storageUtilities";

export const LogoutButton = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { handleTokenAvailable } = useContext(UserContext);

    const handleLogout = useCallback(() => {
        logout();
        handleTokenAvailable(false);
        navigate(`/${HMI_PATHS.ROOT_PATH}/${HMI_PATHS.LOGIN}`);
        resetLocalStorage([LocalStorageGlobalKeys.LANGUAGES, LocalStorageGlobalKeys.I18_LANGUAGE_SELECTION]);
        window.location.reload();
    }, [navigate, handleTokenAvailable]);

    return (
        <div>
            <Button variant="contained" onClick={handleLogout}>
                {t("login.logout")}
            </Button>
        </div>
    );
};
